import APIKI from './Apikit/apikit';

export const getShopsCart = async shopId => {
  const shopsCart = await APIKI.get(
    `/api/v1/shops/carts/?is_purchased=false&shop=${shopId}`,
  ).catch(err => err);

  return shopsCart.data;
};
